module.exports = __webpack_public_path__ + "static/media/chatbotavatar1.91943842.svg";